import * as React from 'react';
import TextField from '@mui/material/TextField';

const Input = ({ value, onInputChange }) => {
    return (
        <TextField
            id="outlined-basic"
            label=""
            variant="outlined"
            // fullWidth
            value={value}
            onChange={onInputChange}
            sx={{ boxSizing: 'border-box', width: '100%' }}
        />
    );
}

export default Input
